import React, { useState } from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import LateReportDayWise from "./Late_report";
import LateReportWeekly from "./Weekly_late_report";
import LateReportMonthly from "./Monthly_late_report";

/**
 * Wraps the Day Wise, Weekly and Monthly late reports as tabs that toggle with
 * state (like the Overtime Report) — all stay mounted, so switching is instant
 * with no route change and no reload.
 */
const LateReportTabs = () => {
  const [activeTab, setActiveTab] = useState("day");

  return (
    <div className="container-fluid mt-4">
      <ToastContainer position="bottom-right" />

      {/* Tabs */}
      <div className="mb-3 d-flex flex-wrap" style={{ gap: "10px" }}>
        <button
          type="button"
          className={`btn btn-sm ${activeTab === "day" ? "btn-primary" : "btn-outline-secondary"}`}
          onClick={() => setActiveTab("day")}
        >
          Day Wise Late Report
        </button>
        <button
          type="button"
          className={`btn btn-sm ${activeTab === "week" ? "btn-primary" : "btn-outline-secondary"}`}
          onClick={() => setActiveTab("week")}
        >
          Weekly Late Report
        </button>
        <button
          type="button"
          className={`btn btn-sm ${activeTab === "month" ? "btn-primary" : "btn-outline-secondary"}`}
          onClick={() => setActiveTab("month")}
        >
          Month Wise Late Report
        </button>
      </div>

      {/* All stay mounted; only the active one is shown */}
      <div style={{ display: activeTab === "day" ? "block" : "none" }}>
        <LateReportDayWise />
      </div>
      <div style={{ display: activeTab === "week" ? "block" : "none" }}>
        <LateReportWeekly />
      </div>
      <div style={{ display: activeTab === "month" ? "block" : "none" }}>
        <LateReportMonthly />
      </div>
    </div>
  );
};

export default LateReportTabs;
